export const GET_LOADING = 'GET_LOADING'
export const GET_PENDING = 'GET_PENDING'
export const GET_PARTICIPATION = 'GET_PARTICIPATION'
export const GET_EVALUATION_LIST = 'GET_EVALUATION_LIST'
export const GET_EVALUATION_TREE = 'GET_EVALUATION_TREE'
export const GET_CRITERIA_SET = 'GET_CRITERIA_SET'
export const SHOW_PARTICIPATION_COMPLETED_POPUP = 'SHOW_EVALUTATION_POPUP'
export const PROGRESS = 'PROGRESS'
export const PROGRESS_FORMATTED = 'PROGRESS_FORMATTED'
